module.exports = __webpack_public_path__ + "static/img/sex_abuse.a5a8f676.png";